import useDeviceDetect from 'components/DeviceDetect'
import ProductItem from 'components/Widgets/ProductItem'
import { ProductItemSkeleton } from 'components/Widgets/ProductItem'
import React from 'react'
import {
  CommentImageSlider,
  CustomSlide,
  CustomSlider,
  ProductImageSlider,
  ProductItemsSlider,
  ProductPictureSmall,
  RightPaneItems,
  RightPaneRelatedTitle,
} from './Slider.style'

const customPageElement = (i, images) => (
  <a href="#/">
    <ProductPictureSmall src={images[i] ? images[i].url : ''} />
  </a>
)

const Slider = props => {
  const propSettings = props.settings || {}
  const { isBrowser } = useDeviceDetect()
  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    ...propSettings,
  }

  switch (props.type) {
    case 'product-image': {
      const productImageSettings = {
        ...settings,
        customPaging: i => customPageElement(i, props.productImages),
        dotsClass: 'slick-dots slick-thumb',
        arrows: false,
      }

      return (
        <ProductImageSlider {...productImageSettings}>
          {props.productImages
            ? props.productImages.map((image, index) => (
                <div className="product-image" key={index}>
                  {/* <ReactImageMagnify
                    isHintEnabled={false}
                    shouldHideHintAfterFirstActivation={false}
                    enlargedImagePosition="beside"
                    enlargedImagePortalId="enlarged-photo"
                    smallImage={{
                      isFluidWidth: true,
                      src: image.url,
                    }}
                    largeImage={{
                      width: 1200,
                      height: 1800,
                      src: image.url,
                    }}
                  /> */}
                </div>
              ))
            : null}
        </ProductImageSlider>
      )
    }
    case 'product-items': {
      const productItemsSettings = {
        ...settings,
        slidesToShow: !isBrowser ? 2 : 5,
        slidesToScroll: !isBrowser ? 2 : 5,

        dots: false,
        infinite: false,
      }
      const { type: _, productItems: __, isLoading, ...prItemProps } = props

      // Show skeleton items when loading
      if (isLoading) {
        const skeletonCount = !isBrowser ? 2 : 5
        return (
          <ProductItemsSlider {...productItemsSettings}>
            {Array(skeletonCount)
              .fill()
              .map((_, index) => (
                <div className="product-item-slide" key={index}>
                  <ProductItemSkeleton />
                </div>
              ))}
          </ProductItemsSlider>
        )
      }

      return (
        <ProductItemsSlider
          itemScope
          itemType="https://schema.org/ItemList"
          {...productItemsSettings}
        >
          {(props.productItems || []).map((item, index) => (
            <div className="product-item-slide" key={index}>
              <ProductItem item={item} {...prItemProps} />
            </div>
          ))}
        </ProductItemsSlider>
      )
    }
    case 'right-product-items': {
      const { type: _, productItems: __, ...prItemProps } = props
      return (
        <>
          <RightPaneRelatedTitle>
            <h2>მსგავსი პროდუქტები</h2>
          </RightPaneRelatedTitle>
          <RightPaneItems>
            {(props.productItems || []).map((item, index) => {
              if (index < 2) {
                return (
                  <div className="product-item-slide" key={index}>
                    <ProductItem
                      className={'right-pane-product'}
                      nohover
                      onlyPictureandPrice={true}
                      item={item}
                      {...prItemProps}
                    />
                  </div>
                )
              }
              return null
            })}
          </RightPaneItems>
        </>
      )
    }
    case 'comment-image': {
      const commentImageSettings = {
        ...settings,
        customPaging: customPageElement,
        dotsClass: 'slick-dots slick-thumb',
        infinite: false,
      }

      return (
        <CommentImageSlider {...commentImageSettings}>
          {props.commentImages
            ? props.commentImages.map((item, index) => (
                <div className="comment-image-slide" key={index}>
                  <img src={item} alt="comment" />
                </div>
              ))
            : null}
        </CommentImageSlider>
      )
    }

    default:
      return <CustomSlider {...settings}>{props.children}</CustomSlider>
  }
}

export const Slide = props => <CustomSlide {...props} />

export default Slider
